"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _Container = _interopRequireDefault(require("../common/Container"));
var _Issues = require("./Issues");
var _Size = require("./Size");
var _License = require("./License");
var _Downloads = _interopRequireDefault(require("./Downloads"));
var _Activity = _interopRequireDefault(require("./Activity"));
var _Version = _interopRequireDefault(require("./Version"));
var _Analysis = _interopRequireDefault(require("./Analysis"));
var _Social = _interopRequireDefault(require("./Social"));
var _jsxRuntime = require("react/jsx-runtime");
var Github = function Github(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container["default"], (0, _objectSpread2["default"])({}, props));
};
Github.Issues = _Issues.Issues;
Github.Size = _Size.Size;
Github.Downloads = _Downloads["default"];
Github.License = _License.License;
Github.Activity = _Activity["default"];
Github.Analysis = _Analysis["default"];
Github.Version = _Version["default"];
Github.Social = _Social["default"];
Github.displayName = 'Github';
var _default = exports["default"] = Github;
module.exports = exports.default;